var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{attrs:{"to":{ name: _vm.getRouteName, params: { id: _vm.client_id }},"target":"_blank"}},[_c('i',{staticClass:"far fa-fw fa-file-export",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('recipient_profile'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }